export default __webpack_public_path__ + "static/media/Templat2.023aa3dd.png";